var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0004 0.54688C13.9995 0.694507 13.9469 0.836213 13.8518 0.943805L7.31849 7.83233C7.27216 7.88587 7.21526 7.92837 7.1526 7.95761C7.08995 7.98684 7.02233 8.00195 6.95391 8.00195C6.88549 8.00195 6.81786 7.98684 6.75521 7.95761C6.69255 7.92837 6.63656 7.88587 6.59023 7.83233L0.103385 0.943806C0.0059243 0.839647 -0.0488284 0.698667 -0.0488285 0.551727C-0.0488285 0.404788 0.00592427 0.263807 0.103385 0.159648C0.202482 0.058352 0.335073 0.00189589 0.472526 0.00189588C0.609978 0.00189588 0.741658 0.058352 0.840755 0.159648L6.95391 6.66094L13.0671 0.159647C13.1662 0.0583514 13.2987 0.00189532 13.4362 0.00189532C13.5737 0.00189531 13.7053 0.0583514 13.8044 0.159647C13.9146 0.256712 13.9848 0.395674 14.0004 0.54688Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow_down.4b91c51b2a92ae8d73d4ffbe60c6f7bc.svg";
export { ForwardRef as ReactComponent };